import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { PhoneGateForm } from "@/components/auth/PhoneGateForm";
import { AngaMark } from "@/components/brand/AngaMark";
import { usePlatformConfig } from "@/lib/config";
import { useState } from "react";

export const Route = createFileRoute("/app/phone-gate")({
  component: ReturningPhoneGatePage,
});

function ReturningPhoneGatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { platformName } = usePlatformConfig();
  const [verified, setVerified] = useState(false);

  return (
    <div className="relative min-h-screen bg-background text-foreground">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--primary-soft),_transparent_50%)]" />
      <div className="relative mx-auto flex min-h-[100dvh] max-w-lg flex-col px-5 py-6 pb-[env(safe-area-inset-bottom)] pt-[max(1.5rem,env(safe-area-inset-top))]">
        <header className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-md bg-[#064E3B] text-white">
            <AngaMark className="h-6 w-6" title={platformName} />
          </div>
          <div className="min-w-0 flex-1">
            <p className="truncate font-display text-lg font-bold leading-none">{platformName}</p>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.16em] text-muted-foreground">
              {t("onboarding.phoneGate.title")}
            </p>
          </div>
        </header>

        <h1 className="font-display text-3xl font-bold">{t("onboarding.phoneGate.title")}</h1>
        <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
          {t("onboarding.phoneGate.body")}
        </p>

        <div className="mt-8">
          {verified ? (
            <p className="rounded-md border border-success/25 bg-success-soft px-3 py-2 text-sm text-success">
              {t("onboarding.phoneGate.verified")}
            </p>
          ) : (
            <PhoneGateForm onVerified={() => setVerified(true)} />
          )}
        </div>

        <div className="mt-auto space-y-2 pt-10">
          <Button
            className="w-full"
            disabled={!verified}
            onClick={() => void navigate({ to: "/app/home" })}
          >
            {t("onboarding.phoneGate.goHome")}
          </Button>
        </div>
      </div>
    </div>
  );
}
